import React, { useCallback } from 'react'
import { StyleSheet, View, ImageBackground } from 'react-native'

import { useNavigation } from '@react-navigation/native'
import { useTranslation } from 'react-i18next'

import Button from './Button'
import Separator from './Separator'
import Typography from './Text/Typography'
import { SIDE_COLUMN_CONTENT_WIDTH } from '../providers/WebLayoutProvider'
import GradientBackground from '../screens/welcome/components/GradientOverlay'
import Colors from '../styles/Colors'
import { MainStackNavigationType } from '../types/navigation-types'

const BACKGROUND_COLOR = '#1E352A'
const GRADIENT_STOPS = [
  { color: BACKGROUND_COLOR, offset: 0, opacity: 1 },
  { color: '#254B39', offset: 1, opacity: 1 },
]

type Props = { variant: 'wide' | 'large' }

export function EBookBanner({ variant }: Props) {
  const { navigate } = useNavigation<MainStackNavigationType<'Root'>>()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'ebookBanner',
  })
  const onButtonPress = useCallback(() => {
    navigate('EBookPreview')
  }, [navigate])

  return (
    <View
      style={[
        styles.ebookBanner,
        variant === 'wide' && styles.ebookBannerWide,
      ]}>
      <GradientBackground gradientKey="ebook" stops={GRADIENT_STOPS} />
      <ImageBackground
        style={styles.overlay}
        source={require('../assets/web-info-column/ebook-banner-overlay.png')}
      />

      <ImageBackground
        style={styles.image}
        source={require('../assets/web-info-column/ebook-banner-image.png')}
      />
      <Typography
        style={[styles.title, variant === 'large' && styles.titleLarge]}>
        {t('title')}
      </Typography>
      <Separator height={variant === 'large' ? 24 : 15} />
      <View style={styles.buttonHolder}>
        <Button
          text={t('button')}
          style={styles.button}
          onPress={onButtonPress}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  ebookBanner: {
    height: 293,
    paddingTop: 23,
    borderRadius: 10,
    paddingBottom: 21,
    overflow: 'hidden',
    paddingHorizontal: 20,
    width: SIDE_COLUMN_CONTENT_WIDTH,
    backgroundColor: BACKGROUND_COLOR,
  },
  ebookBannerWide: {
    width: '100%',
    height: 193,
  },
  overlay: {
    right: 0,
    bottom: 0,
    height: 293,
    position: 'absolute',
    width: SIDE_COLUMN_CONTENT_WIDTH,
  },
  image: {
    right: 0,
    height: 179,
    bottom: -20,
    position: 'absolute',
    width: SIDE_COLUMN_CONTENT_WIDTH,
  },
  title: {
    fontSize: 18,
    color: Colors['layout.white'],
  },
  titleLarge: {
    fontSize: 24,
    marginRight: 60,
  },
  buttonHolder: { marginRight: 'auto' },
  button: {
    padding: undefined,
    paddingTop: 11,
    paddingBottom: 10,
    paddingHorizontal: 20,
  },
})
